export const NumberOfFollowers = [
	{
		"value": 1000,
		"label": '1K'
	},
	{
		"value": 2000,
		"label": '2K'
	},
	{
		"value": 5000,
		"label": '5K'
	},
	{
		"value": 10000,
		"label": '10k'
	},
	{
		"value": 20000,
		"label": '20k'
	},
	{
		"value": 50000,
		"label": '50k'
	},
	{
		"value": 100000,
		"label": '100k'
	},
	{
		"value": 100001,
		"label": '100k+'
	}
];
